import PropTypes from 'prop-types';
import React from 'react';
import { ThemeProvider } from 'styled-components';

import internalTheme from '../styles/internal';

const InternalTheme = ({ children }) => (
  <ThemeProvider theme={internalTheme}>{children}</ThemeProvider>
);

InternalTheme.propTypes = {
  children: PropTypes.node.isRequired,
};

export default InternalTheme;
